import React, { useRef } from "react";

import { CalendarGrid } from "./CalendarGrid";
import { CalendarHeader } from "./CalendarHeader";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import VStack from "shared/components/layout/stack/VStack";
import { createCalendar } from "@internationalized/date";
import styled from "styled-components";
import { useLocale } from "@react-aria/i18n";
import { useRangeCalendar } from "@react-aria/calendar";
import { useRangeCalendarState } from "@react-stately/calendar";

const CalendarWrapper = styled(HStack)`
    padding: 0px 15px;
    height: 168px;
`;

const RangeCalendarWrapper = styled(VStack)`
    width: 402px;
`;

const CalendarFooter = styled(HStack)`
    padding: 0px 20px 10px 20px;
`;

export function RangeCalendar({
    disableDays,
    enableDaysFromDate,
    enableDaysUntilDate,
    minDate,
    onClickCancel,
    onClickDone,
    ...props
}) {
    let { locale } = useLocale();
    let ref = useRef();

    let state = useRangeCalendarState({
        ...props,
        visibleDuration: { months: 2 },
        locale,
        createCalendar,
    });

    let { calendarProps, prevButtonProps, nextButtonProps } = useRangeCalendar(
        props,
        state,
        ref
    );

    return (
        <RangeCalendarWrapper>
            <CalendarHeader
                state={state}
                calendarProps={calendarProps}
                prevButtonProps={prevButtonProps}
                nextButtonProps={nextButtonProps}
                minDate={minDate}
            />
            <VStack spacing="One">
                <CalendarWrapper spacing="One" ref={ref}>
                    <CalendarGrid
                        enableDaysFromDate={enableDaysFromDate}
                        enableDaysUntilDate={enableDaysUntilDate}
                        disableDays={disableDays}
                        state={state}
                    />
                    <CalendarGrid
                        enableDaysFromDate={enableDaysFromDate}
                        enableDaysUntilDate={enableDaysUntilDate}
                        disableDays={disableDays}
                        state={state}
                        offset={{ months: 1 }}
                    />
                </CalendarWrapper>
                <CalendarFooter justify="space-between">
                    <TertiaryButton label="Cancel" onClick={onClickCancel} />
                    <TertiaryButton label="Done" onClick={onClickDone} />
                </CalendarFooter>
            </VStack>
        </RangeCalendarWrapper>
    );
}

RangeCalendar.propTypes = {
    disableDays: PropTypes.array,
    enableDaysFromDate: PropTypes.number,
    enableDaysUntilDate: PropTypes.number,
    minDate: PropTypes.object,
    onClickCancel: PropTypes.func,
    onClickDone: PropTypes.func,
};
